import { gql } from "@apollo/client";

export const GET_DASHBOARD_METRICS = gql`
  query loadPartnerUserJobDashboardMetrics(
    $metricsRangeType: MetricsRangeType!
  ) {
    getPartnerUserJobDashboardMetrics(
      metricsRangeType: $metricsRangeType
    ) {
      userJobMetrics {
        currentPeriod {
          totalJobs
          completedJobs
          inProgressJobs
          pendingJobs
          averageCompletionTime
          onTimeDelivery
          customerSatisfaction
          jobDistribution {
            subCategory
            count
          }
          recentActivityData {
            id
            subCategory
            status
            description
            booking{
              referenceNumber
            }
            updatedAt
            updatedBy {
              id
              firstName
              lastName
            }
          }
          completionTimeData {
            subCategory
            averageDuration
          }
          locationDistribution {
            location
            count
          }
        }
        previousPeriod {
          totalJobs
          completedJobs
          inProgressJobs
          pendingJobs
          averageCompletionTime
          onTimeDelivery
          customerSatisfaction
          jobDistribution {
            subCategory
            count
          }
          recentActivityData {
            id
            description
          }
          completionTimeData {
            subCategory
            averageDuration
          }
        }
        percentageChange {
          totalJobs
          completedJobs
          inProgressJobs
          pendingJobs
          averageCompletionTime
          customerSatisfaction
        }
      }
      partnerDriversMetrics {
        statusCount {
          active
          inactive
          suspended
        }
        skillsDistribution {
          skill
          count
        }
        topDrivers {
          completedJobs
          averageRating
          driver {
            id
          partnerId
          branchId
          firstName
          lastName
          email
          phoneNumber {
            phone
            country
          }
          dateOfBirth
          license {
            licenseNumber
            images
            dateOfExpiry
            authority
            endorsement
            images
          }
          status
          profilePicture
          skills
          createdAt
          updatedAt
          }
        }
      }
    }
  }
`;